import PortalIdParser from 'PortalIdParser';
const ACCEPTANCE_TEST_PORTAL_IDS = [99689734, 104450377, 103126834];
export const isAcceptanceTestPortal = () => ACCEPTANCE_TEST_PORTAL_IDS.includes(PortalIdParser.get());